var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10998_2082)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10998_2082)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10998_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 10.5625H1.4375C1.11427 10.5625 0.804274 10.4341 0.575714 10.2055C0.347154 9.97698 0.21875 9.66698 0.21875 9.34375V3.65625C0.21875 3.33302 0.347154 3.02302 0.575714 2.79446C0.804274 2.5659 1.11427 2.4375 1.4375 2.4375H9.5625C9.88573 2.4375 10.1957 2.5659 10.4243 2.79446C10.6528 3.02302 10.7812 3.33302 10.7812 3.65625V9.34375C10.7812 9.66698 10.6528 9.97698 10.4243 10.2055C10.1957 10.4341 9.88573 10.5625 9.5625 10.5625ZM1.4375 3.25C1.32976 3.25 1.22642 3.2928 1.15024 3.36899C1.07405 3.44517 1.03125 3.54851 1.03125 3.65625V9.34375C1.03125 9.45149 1.07405 9.55483 1.15024 9.63101C1.22642 9.7072 1.32976 9.75 1.4375 9.75H9.5625C9.67024 9.75 9.77358 9.7072 9.84976 9.63101C9.92595 9.55483 9.96875 9.45149 9.96875 9.34375V3.65625C9.96875 3.54851 9.92595 3.44517 9.84976 3.36899C9.77358 3.2928 9.67024 3.25 9.5625 3.25H1.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 8.9375H2.25C2.14226 8.9375 2.03892 8.8947 1.96274 8.81851C1.88655 8.74233 1.84375 8.63899 1.84375 8.53125C1.84375 8.42351 1.88655 8.32017 1.96274 8.24399C2.03892 8.1678 2.14226 8.125 2.25 8.125H4.6875C4.79524 8.125 4.89858 8.1678 4.97476 8.24399C5.05095 8.32017 5.09375 8.42351 5.09375 8.53125C5.09375 8.63899 5.05095 8.74233 4.97476 8.81851C4.89858 8.8947 4.79524 8.9375 4.6875 8.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 5.28125H0.625C0.517256 5.28125 0.413925 5.23845 0.337738 5.16226C0.261551 5.08608 0.21875 4.98274 0.21875 4.875C0.21875 4.76726 0.261551 4.66392 0.337738 4.58774C0.413925 4.51155 0.517256 4.46875 0.625 4.46875H10.375C10.4827 4.46875 10.5861 4.51155 10.6623 4.58774C10.7384 4.66392 10.7812 4.76726 10.7812 4.875C10.7812 4.98274 10.7384 5.08608 10.6623 5.16226C10.5861 5.23845 10.4827 5.28125 10.375 5.28125Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10998_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10998_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 9,
    fill: "white",
    transform: "translate(0 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10998_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/payment_history.0c7ddf23e6a2b23a5abf1fa3fa92fa76.svg";
export { ForwardRef as ReactComponent };